import { lazy, Suspense } from "react";
import { createBrowserRouter } from "react-router";
import { Loading } from "./components/ui";
import { RedirectIfAuthed, RequireAuth, RootRedirect } from "./components/RequireAuth";
import { Shell } from "./components/Shell";
import { ChapterPage } from "./pages/Chapter";
import { LoginPage } from "./pages/Login";
import { MyStoriesPage } from "./pages/MyStories";
import { NotFoundPage } from "./pages/NotFound";
import { PlayingPage } from "./pages/Playing";
import { PublicStoriesPage } from "./pages/PublicStories";
import { ScenePage } from "./pages/Scene";
import { SignupPage } from "./pages/Signup";
import { StoryEditPage } from "./pages/StoryEdit";
import { StoryLandingPage } from "./pages/StoryLanding";
// React Flow + dagre only load when the map is opened.
const StoryMapPage = lazy(() => import("./pages/StoryMap").then((m) => ({ default: m.StoryMapPage })));
import { PlaySessionPage } from "./pages/PlaySession";
import { ProfilePage } from "./pages/Profile";

// Routes follow CONCEPT.md §12.6 exactly.
export const router = createBrowserRouter([
  { path: "/", element: <RootRedirect /> },

  {
    element: <RedirectIfAuthed />,
    children: [
      { path: "/login", element: <LoginPage /> },
      { path: "/signup", element: <SignupPage /> },
    ],
  },

  {
    element: <RequireAuth />,
    children: [
      {
        element: <Shell />,
        children: [
          { path: "/stories", element: <PublicStoriesPage /> },
          { path: "/stories/:storyId", element: <StoryLandingPage /> },
          { path: "/stories/:storyId/sessions/:sessionId", element: <PlaySessionPage /> },
          { path: "/my-stories", element: <MyStoriesPage /> },
          { path: "/playing", element: <PlayingPage /> },
          { path: "/profile", element: <ProfilePage /> },
          { path: "/stories/:storyId/edit", element: <StoryEditPage /> },
          {
            path: "/stories/:storyId/map",
            element: (
              <Suspense fallback={<Loading />}>
                <StoryMapPage />
              </Suspense>
            ),
          },
          { path: "/stories/:storyId/chapters/:chapterId", element: <ChapterPage /> },
          {
            path: "/stories/:storyId/chapters/:chapterId/scenes/:sceneId",
            element: <ScenePage />,
          },
          { path: "*", element: <NotFoundPage /> },
        ],
      },
    ],
  },
]);
